import * as actionTypes from '../actions/actionTypes';

const initialState = {
    loading: true,
    error: null,
    arbitrators: null,
};

const arbitratorReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.ARBITRATOR_START:
            return {
                ...state,
            };
        case actionTypes.ARBITRATOR_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                arbitrators: action.payload,
            };
        case actionTypes.ARBITRATOR_FAIL:
            return {
                ...state,
                error: action.error,
            };
        default:
            return state;
    }
};

export default arbitratorReducer;